import ProductReviews from '../ProductReviews';
import ProductAskAndAnswer from '../ProductAskAndAnswer';
import styles from './ProductReviewsAndAnswersContainer.module.scss';

const ProductReviewsAndAnswersContainer = ({
  productCode,
  productReviewData,
  openReviewsAccordion,
}: {
  productCode: string;
  productReviewData: {
    numberOfReviews: number;
    summationOfRatings: number;
  };
  openReviewsAccordion: boolean;
}) => {
  return (
    <section className={styles.root}>
      <ProductReviews
        productCode={productCode}
        productReviewData={productReviewData}
        reviewsAccordionOpen={openReviewsAccordion}
      />
      <ProductAskAndAnswer
        productCode={productCode}
        reviewCount={productReviewData?.numberOfReviews}
      />
    </section>
  );
};

export default ProductReviewsAndAnswersContainer;
